import Head from "next/head"
import { useRouter } from "next/router"
import { Banner, Container } from "@octopus-energy/coral/atoms"
import { useCoralConfig } from "@octopus-energy/coral/providers"
import { coralBloks } from "@octopus-energy/coral/storyblok"
import { render } from "storyblok-rich-text-react-renderer-ts"
import { PageLoader } from "@/components/organisms"
import { initStoryblok } from "../lib/initStoryblok"
import { getDefaultStringResolver } from "../utils/getDefaultStringResolver"
import { getMarkResolvers } from "../utils/getMarkResolvers"
import { getNodeResolvers } from "../utils/getNodeResolvers"
import { components } from "./index"
import { type StoryblokLayoutProps } from "./StoryblokLayout"

initStoryblok({
    ...components,
    ...coralBloks,
})

export function StoryblokHeadlessLayout({ children, globalBanner, css }: StoryblokLayoutProps) {
    const router = useRouter()
    const { headerHeight } = useCoralConfig()

    if (router.isFallback) {
        return <PageLoader />
    }

    return (
        <>
            {css && (
                <Head>
                    <style>{css}</style>
                </Head>
            )}

            {globalBanner?.content?.content && (
                <Container
                    position="sticky"
                    top={headerHeight ?? 0}
                    zIndex={2}
                >
                    <Banner>
                        {render(globalBanner.content.content, {
                            markResolvers: getMarkResolvers("inherit"),
                            nodeResolvers: getNodeResolvers(),
                            defaultStringResolver: getDefaultStringResolver,
                        })}
                    </Banner>
                </Container>
            )}

            {children}
        </>
    )
}
